__webpack_require__.p = "/mi-assets/mi-static/mi-homepage-renderer/web-rel-26.10.1-100626530/_next/";